if (!customElements.get('rm-share')) {
  customElements.define('rm-share', class RmShare extends HTMLElement {
    constructor() {
      super();

      if (navigator.share) {
        this.addEventListener('click', () => { navigator.share({ url: document.location.href, title: document.title }) });
      } else {
        this.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(document.location.href).then(() => {
        alert('URL copied to clipboard.')
      });
    }
  });
}